import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../components/BackDrop_Spinner";
import SearchIcon from "@mui/icons-material/Search";
import {
  handleTreeChange,
  Set_ORG_ID_CONST,
  update_one_side_PDF_Key,
  updateAthenaStorage,
  updateChangeLogs,
  updateDynamicOption_Done,
  updateStoreVals,
} from "../../redux/VR2/vr2Actions";

import Popup from "../../components/SimplePOPUP";
import { getRequest, postRequest } from "../../globalhelper/helper";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { styled, width } from "@mui/system";
import { Table } from "react-bootstrap";

import { Tooltip } from "@mui/material";

import Select from "react-select";

import { externals } from "../../config.json";

import ProgressComponent from "../../components/progressComponent";
import { showAlert } from "../../redux/Common/commonActions";
import store from "../../store";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
export class form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logs: {},
      showPopUP_PDF: false,
      popData_PDF: false,
      fileType: "",
      showSpinner: false,
      dynamicOption: [],
      token: this.props.screenName,
      popup_select: [],
      open_popup_select: false,
      popup_table: false,
      Give_Val_By_ServiceKey: {},
      ValidationError: {},
      stop_flag: false,
      selectedVendorName: "",
      selectedLedgerName: "",
      similarity12: 0,
      similarity13: 0,
      similarity23: 0,
      showSimilarityPopup: false,
      similarityresult12: 0, // display in screen
      // modal
      showModal: false,
      autoSelected: {},

      billvendorname: localStorage.getItem("billvendorname"),
      vendorNameAsPerMaster: localStorage.getItem("vendornameAsperMaster")
        ? localStorage.getItem("vendornameAsperMaster")
        : "no value",
      vendorLedgerName: localStorage.getItem("vendorledgerName"),

      ROW: null,
    };
  }

  componentDidMount() {
    this.TaxCategory();
    this.storeInputSearchValuesInLocalStorage();

    setTimeout(() => {
      if (
        this.state.token === "BillExtract" &&
        this.props.tree.title === "Vendor Account Info"
      ) {
        this.autoSelectVendorNamePopup();
      }
    }, 2000);

    this.initialhandleCheckSimilarity(
      this.state.billvendorname,
      this.state.vendorNameAsPerMaster,
    );
  }

  storeInputSearchValuesInLocalStorage = () => {
    this.props.tree.children?.forEach((treenode) => {
      if (treenode.type === "section" && treenode.view === "form") {
        treenode.children?.forEach((childNode) => {
          if (childNode.type === "input_search" && childNode.val) {
            localStorage.setItem("billvendorname", childNode.val);
          } else if (childNode.type === "input_vendormasternamestatus") {
            localStorage.setItem("vendornameAsperMaster", childNode.val);
          } else if (childNode.type === "input_ledgernamestatus") {
            localStorage.setItem("vendorledgerName", childNode.val);
          }
        });
      }
    });
  };

  initialhandleCheckSimilarity = (name1, name2) => {
    const similarityresult12 = this.calculateHighestSimilarity(name1, name2);

    this.setState({ similarityresult12: Math.ceil(similarityresult12) });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.time !== nextProps.time) {
      this.setState({
        arvind: "python master",
      });
    }
  }

  myChangeHandler = (event, childrenNode, date) => {
    let serviceKey = event.target.name;
    let serviceID = event.target.id;
    let val = event.target.value;

    if (date) {
      let date = moment(val, "YYYY-MM-DD").format("DD-MM-YYYY");

      val = date === "Invalid date" ? val : date;
    }
    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    logs[serviceID] = {
      serviceKey: serviceKey,
      serviceID: serviceID,
      value: val,
      DateTime,
      user: this.props?.userData?.USR_Email,
    };

    vals[serviceID] = val;

    if (childrenNode.changeAll && childrenNode.changeAll === "true") {
      this.changeValByserviceID(
        childrenNode.serviceKey,
        "serviceKey",
        "val",
        val,
        "changeAll",
      );
    } else {
      this.changeValByserviceID(serviceID, "serviceID", "val", val);
    }

    this.props.updateChangeLogs(logs);
    this.props.updateStoreVals(vals);
    this.props.rerender("noQuit");
  };

  TaxCategory = (
    OrganizationPlaceofSupply,
    VendorSourceofSupply,
    VendorGSTNumber,
    GSTNumber,
  ) => {
    if (
      OrganizationPlaceofSupply !== undefined &&
      VendorSourceofSupply !== undefined
    ) {
      let val;

      if (
        OrganizationPlaceofSupply !== "" &&
        VendorSourceofSupply !== "" &&
        OrganizationPlaceofSupply !== "-" &&
        VendorSourceofSupply !== "-" &&
        OrganizationPlaceofSupply === VendorSourceofSupply
      ) {
        val = "CGST/SGST";
      } else {
        val = "IGST";
      }

      this.changeValByserviceID("Tax Category", "serviceKey", "val", val);
      this.props.rerender("noQuit");
    } else if (VendorGSTNumber !== undefined && GSTNumber !== undefined) {
      let val;

      if (
        VendorGSTNumber !== "" &&
        GSTNumber !== "" &&
        VendorGSTNumber !== "-" &&
        GSTNumber !== "-" &&
        VendorGSTNumber.substring(0, 2) === GSTNumber.substring(0, 2)
      ) {
        val = "CGST/SGST";
      } else {
        val = "IGST";
      }

      this.changeValByserviceID("Tax Category", "serviceKey", "val", val);
      this.props.rerender("noQuit");
    }
  };

  PO_IPNumber = (obj) => {
    if (obj.type === "popup_select") {
      let Input = {
        PO_IPNumber: obj.val,
        screen: "BillExtract",
      };

      postRequest("api/vr2apicall/PO_IPNumber", Input).then((res) => {
        if (res.res.status === "success") {
          let DATA = JSON.parse(res.res.data);
          let athenaStorage = this.props.athenaStorage;
          athenaStorage["PO_IP_Item_Ref"] = DATA;

          this.props.updateAthenaStorage(athenaStorage);

          let newSet =
            [...new Set(DATA?.map((each) => each["PO/IP Item Ref"]))] || [];

          let options = [];

          newSet?.forEach((one) => {
            options.push({
              label: one,
              value: one,
            });
          });

          this.changeValByserviceID(
            "PO/IP Item Ref",
            "serviceKey",
            "options",
            options,
          );
          this.props.rerender();
        }
      });
    } else if (obj.type === "popup_select_goods") {
      return;
    }
  };

  getOriginalGRN_SRN_No = async (DocumentType) => {
    await this.Give_Val_By_ServiceKey("Sender ID");
    let SenderID = this.state.Give_Val_By_ServiceKey["Sender ID"];

    getRequest(
      `api/vr2apicall/getOriginalGRN_SRN_No?SenderID=${SenderID}&DocumentType=${DocumentType}`,
    ).then((res) => {
      if (res.res.status === "success") {
        let DATA = JSON.parse(res.res.data);
        let athenaStorage = this.props.athenaStorage;

        athenaStorage["Original GRN/SRN Number"] = DATA;

        this.props.updateAthenaStorage(athenaStorage);

        let newSet = [
          ...(new Set(DATA?.map((each) => each["Original GRN/SRN Number"])) ||
            []),
        ];

        let options = [];

        newSet?.forEach((one) => {
          options.push({
            label: one,
            value: one,
          });
        });

        this.changeValByserviceID(
          "Original GRN/SRN Number",
          "serviceKey",
          "options",
          options,
        );
        this.props.rerender();
      }
    });
  };

  VendorIDonChange = () => {
    this.changeValByserviceID(
      "Vendor ID",
      "serviceKey",
      "VendorIDonChange",
      [],
    );

    this.props.onVendorIDonChange();
  };
  SenderIDonChange = () => {
    this.changeValByserviceID(
      "Sender ID",
      "serviceKey",
      "SenderIDonChange",
      [],
    );

    this.props.onVendorIDonChange();
  };
  BillExtractDoUpload = () => {
    this.changeValByserviceID("Upload (PDF)", "serviceKey", "editable", "true");
  };

  TaxCategoryonChange = (val) => {
    this.changeValByserviceID(
      "Tax Percentage",
      "serviceKey",
      "getTaxPercentage",
      val,
    );
  };

  OrgIDConst = (val) => {
    if (this.props.ORG_ID_CONST === "") {
      this.props.Set_ORG_ID_CONST(val);
    }
  };

  updateTaxCode = (TaxPercentage, TaxCategory, serviceID) => {
    let SerID = serviceID.replace("taxpercentage", "taxcode");

    let taxCode = TaxCategory + " " + String(Number(TaxPercentage)) + "%";

    this.changeValByserviceID(SerID, "serviceID", "val", taxCode);
  };

  changeValByserviceID = (serviceID_or_Key, matchBy, key, val, changeAll) => {
    console.log(val, "hereFrom");

    let VR2_Form_Json = this.props.VR2_Form_Json;
    let found = false;
    let OrganizationPlaceofSupply;
    let VendorSourceofSupply;
    let VendorGSTNumber;
    let GSTNumber;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children?.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children?.forEach((each3, k) => {
              if (found) return;

              if (
                changeAll &&
                this.trim(each3[matchBy]) === this.trim(serviceID_or_Key)
              ) {
                each3[key] = val;
                this.props.handleTreeChange(VR2_Form_Json);

                if (each3.serviceKey === "Organization ID")
                  this.OrgIDConst(val);
                if (each3.child_dependency) {
                  let dynamicOption_Done = this.props.dynamicOption_Done;

                  each3.child_dependency?.forEach((per) => {
                    dynamicOption_Done = dynamicOption_Done.filter((item) => {
                      let splitArray = item.split("$");
                      return splitArray.every((part) => part !== per);
                    });
                  });

                  this.props.updateDynamicOption_Done(dynamicOption_Done);
                }
                return;
              } else if (
                !each3.children &&
                each3.render &&
                each3.render === "true" &&
                this.trim(each3[matchBy]) === this.trim(serviceID_or_Key)
              ) {
                each3[key] = val;
                if (
                  key === "options" &&
                  each3.val &&
                  each3.onChange_operation
                ) {
                  this.onChange_operation(each3, each3.val);
                }

                if (each3.serviceKey === "PO/IP Type") {
                  this.props.toParent(val);
                }

                this.props.handleTreeChange(VR2_Form_Json);
                found = true;
                if (each3.serviceKey === "Vendor ID" && key === "val")
                  this.VendorIDonChange();
                if (each3.serviceKey === "Sender ID" && key === "val")
                  this.SenderIDonChange();
                if (
                  this.state.token === "BillExtract" &&
                  each3.serviceKey === "Organization Name" &&
                  key === "val"
                )
                  this.BillExtractDoUpload();
                if (
                  each3.serviceKey === "DocumentType" &&
                  key === "val" &&
                  this.state.token === "GoodsAndServicesEntries"
                )
                  this.getOriginalGRN_SRN_No(val);

                if (each3.serviceKey === "Organization Place of Supply") {
                  OrganizationPlaceofSupply = each3.val;
                } else if (each3.serviceKey === "Vendor Source of Supply") {
                  VendorSourceofSupply = each3.val;
                } else if (each3.serviceKey === "Vendor GST Number") {
                  VendorGSTNumber = each3.val;
                } else if (each3.serviceKey === "GST Number") {
                  GSTNumber = each3.val;
                }
                if (
                  OrganizationPlaceofSupply &&
                  VendorSourceofSupply &&
                  VendorGSTNumber &&
                  GSTNumber
                ) {
                  this.TaxCategory(
                    OrganizationPlaceofSupply,
                    VendorSourceofSupply,
                    VendorGSTNumber,
                    GSTNumber,
                  );
                }
                if (each3.serviceKey === "Tax Category")
                  this.TaxCategoryonChange(val);
                if (
                  each3.serviceKey === "PO/IP Number" ||
                  each3.serviceKey === "Order Number"
                )
                  this.PO_IPNumber(each3);

                if (each3.serviceKey === "Organization ID")
                  this.OrgIDConst(val);
                if (each3.serviceKey === "Receiver ID") this.OrgIDConst(val);

                if (each3.child_dependency) {
                  let dynamicOption_Done = this.props.dynamicOption_Done;

                  each3.child_dependency?.forEach((per) => {
                    dynamicOption_Done = dynamicOption_Done.filter((item) => {
                      let splitArray = item.split("$");
                      return splitArray.every((part) => part !== per);
                    });
                  });

                  this.props.updateDynamicOption_Done(dynamicOption_Done);
                }
                return;
              } else if (each3.children && each3.children?.length) {
                each3.children?.forEach((each4, m) => {
                  if (found) return;

                  if (
                    changeAll &&
                    this.trim(each4[matchBy]) === this.trim(serviceID_or_Key)
                  ) {
                    each4[key] = val;
                    this.props.handleTreeChange(VR2_Form_Json);
                    return;
                  } else if (
                    each4.render === "true" &&
                    this.trim(each4[matchBy]) === this.trim(serviceID_or_Key)
                  ) {
                    if (
                      each4.serviceKey === "Tax Percentage" &&
                      key === "getTaxPercentage"
                    ) {
                      this.updateTaxCode(each4.val, val, each4.serviceID);
                    } else {
                      each4[key] = val;
                      this.props.handleTreeChange(VR2_Form_Json);
                      found = true;
                      return;
                    }
                  }
                });
              }
            });
          }
        });
      }
    });
  };

  option_undef = (childrenNode) => {
    let formArray_obj = {};

    if (childrenNode.val) {
      let ev = {
        target: {
          id: childrenNode.serviceID,
          name: childrenNode.serviceKey,
          value: childrenNode.val,
        },
      };

      this.onDropDownValueChange(ev, "false", "no_onBlur");
    }
  };

  onDropDownValueChange = (ev, valEmpty, no_onBlur) => {
    let serviceID = ev.target.id;
    let serviceKey = ev.target.name;
    let val = ev.target.value;

    this.changeValByserviceID(serviceID, "serviceID", "val", val);

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    logs[serviceID] = {
      serviceKey: serviceKey,
      serviceID: serviceID,
      value: val,
      DateTime,
      user: this.props?.userData?.USR_Email,
    };
    vals[serviceID] = val;

    let formArray_obj = {};

    this.props.updateChangeLogs(logs);
    this.props.updateStoreVals(vals);

    this.props.rerender();
    this.setState(
      { [serviceKey]: val, logs },

      () =>
        no_onBlur
          ? null
          : this.onBlur({
            target: {
              id: serviceID,
              value: val,
            },
          }),
    );
  };

  if2hashRemoveLast = (myString) => {
    if (myString.includes("#") && (myString.match(/#/g) || [])?.length === 2) {
      let str = myString.split("#");

      str.splice(-1);

      return str.join("#");
    } else {
      return myString;
    }
  };

  onBlur = (e, childrenNode) => {
    let val = e.target.value;
    let id = e.target.id;

    if (val) {
      let API = _.filter(
        this.props.dependency_json,
        (item) =>
          item.type === "apiCall" &&
          item.parentId === this.if2hashRemoveLast(id),
      );

      if (API?.length && API?.length === 1) {
        let obj = {
          LOGS: this.props.changeLogs,
          TREE_JSON: this.props.VR2_Form_Json,
        };

        this.setState({ showSpinner: true }, () => {
          postRequest(
            `api/vr2/EditJson?module=${localStorage.getItem(
              "module",
            )}&screenName=${this.state.token}`,
            obj,
          ).then((res) => {
            if (res.res.status === "success") {
              this.props.handleTreeChange(res.res.data);

              if (this.state.token === "BillExtract") {
                this.putDefaultValue_BillExtract("DocumentType", "Bill");
                this.putDefaultValue_BillExtract("ExchangeRate", "1");
              }

              if (
                childrenNode &&
                childrenNode.range_fn &&
                childrenNode.range_fn === "extract_pdf"
              ) {
                this.changeValByserviceID(
                  childrenNode.serviceID,
                  "serviceID",
                  "editable",
                  "false",
                );
                this.autoSelectVendorNamePopup();
                this.props.rerender();
              }
            }

            this.setState({ showSpinner: false });
          });
        });
      }
    }
  };

  autoSelectVendorNamePopup = () => {
    let VR2_Form_Json = this.props.VR2_Form_Json;
    let found = false;
    let goAhead;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children?.forEach((each2, j) => {
          if (found) return;

          if (
            each2.title === "Vendor Account Info" &&
            each2.children &&
            each2.children?.length
          ) {
            each2.children?.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3.render &&
                each3.render === "true" &&
                each3.serviceKey === "Vendor ID"
              ) {
                if (!each3.val) {
                  goAhead = true;
                }
              }
              if (
                !each3.children &&
                each3.render &&
                each3.render === "true" &&
                each3.serviceKey === "Vendor Name" &&
                each3.type === "input_search" &&
                goAhead
              ) {
                this.input_select_fn(each3);

                found = true;
                return;
              }
            });
          }
        });
      }
    });
  };

  putDefaultValue_BillExtract = (KEY, VAL) => {
    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children?.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children?.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3.render &&
                each3.render === "true" &&
                each3.serviceKey === KEY
              ) {
                if (!each3.val) {
                  each3.val = VAL;
                  this.props.handleTreeChange(VR2_Form_Json);
                }

                found = true;
                return;
              }
            });
          }
        });
      }
    });
  };

  date_DD_MM_YYYY_TO_YYYY_MM_DD = (json) => {
    let ok = JSON.parse(JSON.stringify(json));

    let date = moment(ok.val, "DD-MM-YYYY").format("YYYY-MM-DD");

    return date === "Invalid date" ? ok.val : date;
  };

  current_date = (childrenNode) => {
    let date = moment(new Date()).format("DD-MM-YYYY");
    let ev = {
      target: {
        id: childrenNode.serviceID,
        name: childrenNode.serviceKey,
        value: date,
      },
    };

    this.myChangeHandler(ev, childrenNode);
  };

  yesterday_date = (childrenNode) => {
    let date = moment(new Date()).subtract(1, "day").format("DD-MM-YYYY");
    let ev = {
      target: {
        id: childrenNode.serviceID,
        name: childrenNode.serviceKey,
        value: date,
      },
    };

    this.myChangeHandler(ev, childrenNode);
  };

  get_user_email = (childrenNode) => {
    let user = this.props?.userData?.USR_Email;

    let ev = {
      target: {
        id: childrenNode.serviceID,
        name: childrenNode.serviceKey,
        value: user,
      },
    };

    this.myChangeHandler(ev, childrenNode);
  };

  generateUniqueNumber = () => {
    var timestamp = new Date().getTime();
    var uniqueNumber = timestamp.toString().substr(0, 10);

    return uniqueNumber;
  };

  removeSpecialCharacters_exceptDOT = (str) => {
    return str.replace(/[^\w\s.]/gi, ""); // only dot allowed
  };

  removeSpecialCharacters = (str) => {
    return str.replace(/[^\w\s]/gi, "");
  };

  onUpload = (e, childrenNode) => {
    let serviceKey = e.target.name;
    let serviceID = e.target.id;

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    const files = Array.from(e.target.files);
    const totalSize = files.reduce((acc, file) => acc + file.size, 0);

    const { MAX_TOTAL_SIZE } = externals;

    let file = e.target.files[0];
    if (
      file &&
      e.target.files &&
      e.target.files?.length &&
      files.every((file) => file.name.toLowerCase().includes("pdf")) &&
      Number(MAX_TOTAL_SIZE) > totalSize
    ) {
      let fileName =
        this.generateUniqueNumber() +
        this.removeSpecialCharacters_exceptDOT(file.name);

      const Module = localStorage.getItem("module");
      const screenName = this.removeSpecialCharacters(this.state.token);
      const fieldName = this.removeSpecialCharacters(serviceKey);

      let s3key = `UploadedFiles/${Module}/${screenName}/${fieldName}/${fileName}`;

      const formData = new FormData();
      formData.append("file", file);

      postRequest(
        `api/vr2/uploadPDF?module=${localStorage.getItem(
          "module",
        )}&screenName=${screenName}&fieldName=${fieldName}&fileName=${fileName}`,
        formData,
      ).then((res) => {
        if (res.res.status === "success") {
          this.changeValByserviceID(serviceID, "serviceID", "val", s3key);

          logs[serviceID] = {
            serviceKey: serviceKey,
            serviceID: serviceID,
            value: s3key,
            DateTime,
            user: this.props?.userData?.USR_Email,
          };
          vals[serviceID] = s3key;

          this.props.updateChangeLogs(logs);
          this.props.updateStoreVals(vals);

          this.props.rerender();
          this.setState(
            {
              [serviceID]: file,
            },
            () =>
              this.onBlur(
                {
                  target: {
                    id: serviceID,
                    value: file,
                  },
                },
                childrenNode,
              ),
          );
        }
      });
      this.setState({ ValidationError: "" });
    } else if (
      files.every((file) => file.name.toLowerCase().includes("pdf")) &&
      MAX_TOTAL_SIZE <= totalSize
    ) {
      this.setState((prevState) => ({
        ValidationError: {
          ...prevState.ValidationError,
          [childrenNode.serviceID]: `The total size of all files must not exceed 50 MB. Currently: ${(
            totalSize /
            (1024 * 1024)
          ).toFixed(2)} MB`,
        },
      }));
    } else {
      this.setState((prevState) => ({
        ValidationError: {
          ...prevState.ValidationError,
          [childrenNode.serviceID]: "This field extension is mismatching",
        },
      }));
    }
  };

  base64ToBlob = (base64, mimeType) => {
    const byteArray = Uint8Array.from(atob(base64), (char) =>
      char.charCodeAt(0),
    );
    return new Blob([byteArray], { type: mimeType });
  };

  openPDF = (e, childrenNode) => {
    e?.preventDefault();
    this.props.update_one_side_PDF_Key(false, "");
    postRequest(`api/vr2/getPDF_file`, {
      key: childrenNode?.val,
    }).then((res) => {
      if (res.res.status === "success") {
        const fileType = childrenNode?.val.split(".").at(-1).toLowerCase();
        if (childrenNode?.subtype === "upload_show") {
          const base64Data = res.res.data;
          const mimeType =
            fileType === "pdf"
              ? "application/pdf"
              : `image/${fileType === "jpg" ? "jpeg" : fileType}`;
          const blob = this.base64ToBlob(base64Data, mimeType);
          const url = URL.createObjectURL(blob);

          this.props.update_one_side_PDF_Key(
            url,
            childrenNode?.val.split(".").at(-1),
          );
        } else
          this.setState({
            showPopUP_PDF: childrenNode.serviceID,
            popData_PDF: res.res.data,
            fileType: childrenNode?.val.split(".").at(-1),
          });
      }
    });
  };

  trim = (str) => {
    return str?.replace(/\s+/g, "").toLowerCase();
  };

  dynamic_option_fn = async (childrenNode) => {
    if (childrenNode.editable === "false" && childrenNode.type !== "input") {
      return;
    }
    let hit = `${childrenNode.dynamic_option.api_Directory}?query_Name=${childrenNode.dynamic_option.query_Name}`;
    console.log(hit, "node");

    let array;

    if (childrenNode.dynamic_option.dynamic_query) {
      array = [];

      await childrenNode.dynamic_option.dynamic_query?.forEach(async (each) => {
        if (each.emailid) {
          let obj = {
            replaceStringWith: each.replaceStringWith,
            value: this.props?.userData?.USR_Email,
          };
          array.push(obj);
        } else if (each.getValueFrom === "Organization ID") {
          await this.Give_Val_By_ServiceKey(each.getValueFrom);
          let obj = {
            replaceStringWith: each.replaceStringWith,
            value:
              this.state.Give_Val_By_ServiceKey[each.getValueFrom] ||
              "",
          };
          array.push(obj);
          console.log(this.Give_Val_By_ServiceKey(each.getValueFrom), obj, "obj");
        } else {
          await this.Give_Val_By_ServiceKey(each.getValueFrom);
          let obj = {
            replaceStringWith: each.replaceStringWith,
            value: this.state.Give_Val_By_ServiceKey[each.getValueFrom],
          };
          array.push(obj);
        }
      });
    }

    postRequest(hit, array ? { info: array } : null).then((res) => {
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (DATA?.length) {
          let matchKey = Object.keys(DATA[0]).find(
            (each) => this.trim(each) === this.trim(childrenNode.serviceKey),
          );

          if (matchKey) {
            if (
              childrenNode.dynamic_option.query_Name ===
              "ListofOrganizationName_IP"
            ) {
              this.OrgIDConst(DATA[0]["Organization ID"]);
            }
            if (childrenNode.dynamic_option.what_to_store) {
              let athenaStorage = this.props.athenaStorage;

              athenaStorage[childrenNode.dynamic_option.what_to_store] = DATA;

              this.props.updateAthenaStorage(athenaStorage);
            }

            let newSet =
              [...new Set(DATA?.map((each) => each[matchKey]))] || [];

            let options =
              newSet?.map((one) => {
                return {
                  label: one,
                  value: one,
                };
              }) || [];

            if (
              options?.length === 1 &&
              this.state.autoSelected &&
              childrenNode.val !== options[0].value &&
              childrenNode.val !== ""
            ) {
              this.onChange_operation(childrenNode, options[0].value);
            }

            this.changeValByserviceID(
              childrenNode.serviceID,
              "serviceID",
              "options",
              options,
            );
            this.props.rerender();
          }
        }
      }
    });
  };

  removeSpecialChars = (str) => {
    return str.replace(/[^\w\s]/gi, "");
  };

  onChange_operation = (childrenNode, val) => {
    let ARRAY =
      this.props.athenaStorage[childrenNode.onChange_operation.get_From];

    let changeAll = childrenNode.onChange_operation.changeAll ? true : false;
    console.log(ARRAY, "ARRAY");

    if (ARRAY && ARRAY[0]) {
      let matchKey = Object.keys(ARRAY[0]).find(
        (each) => this.trim(each) === this.trim(childrenNode.serviceKey),
      );
      console.log(matchKey, "match");

      if (matchKey && childrenNode.type !== "multiselect") {
        let LINES = ARRAY.filter((each) => each[matchKey] === val);

        if (
          childrenNode.onChange_operation.operation &&
          childrenNode.onChange_operation.operation === "show_next_dropdown"
        ) {
          let child_Name = childrenNode.onChange_operation.child_Name;

          if (typeof child_Name === "object") {
          } else {
            child_Name = [child_Name];
          }

          child_Name?.forEach((item) => {
            let OPTIONS = [];

            if (LINES?.length) {
              let newSet = [...new Set(LINES?.map((each) => each[item]))] || [];

              newSet?.forEach((each) => {
                OPTIONS.push({
                  label: each,
                  value: each,
                });
              });

              this.changeValByserviceID(
                item,
                "serviceKey",
                "options",
                OPTIONS,
                changeAll,
              );
              this.props.rerender();
            } else {
              this.changeValByserviceID(
                item,
                "serviceKey",
                "options",
                [],
                changeAll,
              );
              this.props.rerender();
            }
          });
        } else {
          if (LINES?.length === 1) {
            let LINE = LINES[0];

            Object.keys(LINE)?.map((one) => {
              if (one !== matchKey) {
                let willStore_val = LINE[one];

                this.changeValByserviceID(
                  one,
                  "serviceKey",
                  "val",
                  willStore_val,
                  changeAll,
                );
                this.props.rerender("noQuit");
              }
            });
          }
        }
      } else if (matchKey && childrenNode.type === "multiselect") {
        let LINES = ARRAY.filter((each) =>
          val.split("#").includes(each[matchKey]),
        );

        if (LINES?.length) {
          let KEYS = Object.keys(LINES[0]);

          let OBJ = {};

          KEYS?.forEach((each) => {
            OBJ[each] =
              [...new Set(LINES?.map((one) => one[each]))].join(",") || "";
          });

          Object.keys(OBJ)?.map((one) => {
            if (one !== matchKey) {
              let willStore_val = OBJ[one];

              this.changeValByserviceID(
                one,
                "serviceKey",
                "val",
                willStore_val,
                changeAll,
              );
              this.props.rerender("noQuit");
            }
          });
        }
      }
    }
  };

  store_all_vals = () => {
    let VALS = this.props.storeVals;

    this.props.VR2_Form_Json?.forEach((each, i) => {
      if (each.children && each.children?.length) {
        each.children?.forEach((each2, j) => {
          if (each2.children && each2.children?.length) {
            each2.children?.forEach((each3, k) => {
              if (!each3.children && each3.render === "true") {
                VALS[each3.serviceID] = each3.val;
              }

              if (each3.children && each3.children?.length) {
                each3.children?.forEach((each4, m) => {
                  if (each4.render === "true") {
                    VALS[each4.serviceID] = each4.val;
                  }
                });
              }
            });
          }
        });
      }
    });

    this.props.updateStoreVals(VALS);
  };

  Give_Val_By_ServiceKey = (serviceKey) => {
    let VALUE;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    this.setState(
      (prev) => ({
        Give_Val_By_ServiceKey: {
          ...prev.Give_Val_By_ServiceKey,
          [serviceKey]: "",
        },
      }),
      () => {
        VR2_Form_Json?.forEach((each, i) => {
          if (found) return VALUE;
          if (each.children && each.children?.length) {
            each.children?.forEach((each2, j) => {
              if (found) return VALUE;
              if (each2.children && each2.children?.length) {
                each2.children?.forEach((each3, k) => {
                  if (found) return VALUE;

                  if (
                    !each3.children &&
                    each3.render &&
                    each3.render === "true" &&
                    each3.serviceKey === serviceKey
                  ) {
                    VALUE = each3.val;

                    this.setState((prev) => ({
                      Give_Val_By_ServiceKey: {
                        ...prev.Give_Val_By_ServiceKey,
                        [serviceKey]: each3.val,
                      },
                    }));

                    if (VALUE) found = true;

                    if (found) return VALUE;
                  }
                });
              }
            });
          }
        });
      },
    );
  };
  input_select_fn = async (childrenNode) => {
    let hit = `${childrenNode.api_info.api_Directory}`;

    await this.Give_Val_By_ServiceKey("Vendor PAN");
    let VendorPAN = this.state.Give_Val_By_ServiceKey["Vendor PAN"];

    await this.Give_Val_By_ServiceKey("Vendor GST Number");
    let VendorGSTNumber =
      this.state.Give_Val_By_ServiceKey["Vendor GST Number"];

    await this.Give_Val_By_ServiceKey("GST Number");
    let GSTNumber = this.state.Give_Val_By_ServiceKey["GST Number"];

    let OrgID = this.props.ORG_ID_CONST;

    let input = {
      VendorName: childrenNode.val,
      VendorPAN,
      VendorGSTNumber,
      GSTNumber, //mbp---uncmtd
      OrgID,
    };

    if (Object.values(input).some((item) => item === "" || item === null || item === undefined)) {
      console.log(hit, "billooo");
      store.dispatch(showAlert(`${Object.keys(input).join(", ")} are required`, "error"));
      return;
    }

    postRequest(hit, input).then((res) => {
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (DATA?.length) {
          this.setState(
            {
              popup_table: {
                search: "",
                data: DATA,
                filteredData: DATA,
                header: Object.keys(DATA[0]),
              },
            },
            () => {
              let popup_table = this.state.popup_table;

              if (
                popup_table &&
                popup_table.data?.length &&
                popup_table.data?.length === 1
              ) {
                this.tableRow_click(popup_table.data[0]);
              } else if (popup_table && popup_table.data?.length) {
                let e = {
                  target: {
                    value: childrenNode.val,
                  },
                };

                this.on_popup_table_search(e);
              }
            },
          );
        }
      }
    });
  };

  popup_select_fn = async (childrenNode) => {
    try {
      this.store_all_vals();

      let tenantID = localStorage.getItem("tenant_id");

      let SerIDS =
        childrenNode.type === "popup_select"
          ? ["Vendor ID", "Vendor GST Number", "GST Number"]
          : childrenNode.type === "popup_select_goods"
            ? ["Order Type", "Sender ID"]
            : [];

      let obj = {};

      for (const each of SerIDS) {
        await this.Give_Val_By_ServiceKey(each);
        obj[each.toLowerCase()] = this.state.Give_Val_By_ServiceKey[each];
      }

      const missing = Object.values(obj).some(
        (item) => item === "" || item === null || item === undefined,
      );
      if (missing && tenantID !== "TID00002") {
        this.props.showAlert(
          `${SerIDS.join(", ")} required — these are not filled`,
          "error",
        );
        return;
      }
      let hit = `${childrenNode.api_info.api_Directory}`;
      console.log(hit, "hit");

      let res = await postRequest(hit, obj);
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (DATA?.length) {
          if (this.state.token === "BillExtract") {
            const even = (element) => {
              if (
                element["PO/IP Type"] === "GoodsReceipt" ||
                element["PO/IP Type"] === "ServiceReceipt"
              ) {
                return element;
              }
            };

            const present = DATA.some(even); // true or false

            if (present) {
              DATA =
                DATA?.map((each) => {
                  if (
                    each["PO/IP Type"] === "PurchaseOrder" ||
                    each["PO/IP Type"] === "InternalPlan"
                  ) {
                    each.disabled = true;
                  }

                  return each;
                }) || [];
            }
          }

          this.setState({
            popup_table: {
              search: "",
              data: DATA,
              filteredData: DATA,
              header: Object.keys(DATA[0]),
            },
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  on_popup_table_search = (e) => {
    const VAL = e.target.value;

    const data = this.state.popup_table.data;

    const filteredData = data.filter((row) =>
      Object.values(row).some(
        (value) =>
          value &&
          value
            .toString()
            .replace(/\s/g, "")
            .toLowerCase()
            .includes(VAL.replace(/\s/g, "").toLowerCase()),
      ),
    );

    this.setState({
      ...this.state,
      popup_table: {
        ...this.state.popup_table,
        search: VAL,
        filteredData: filteredData,
      },
    });
  };

  splitNames = (name) => {
    let cleanedName = name.toLowerCase().replace(/[^a-z0-9\s.-]/g, "");
    cleanedName = cleanedName.replace(/[.-]/g, " ");
    cleanedName = cleanedName.replace(/\s+/g, " ").trim();

    return cleanedName.split(" ");
  };

  expandAbbreviations = (name) => {
    if (!name) return "";
    const name1 = String(name).toLowerCase();
    const replacements = {
      corp: "corporation",
      pvt: "private",
      ltd: "limited",
    };
    const expandedname = name1.replace(
      /\b(corp|pvt|ltd)\b/g,
      (match) => replacements[match],
    );

    return expandedname;
  };

  calculateHighestSimilarity = (sourceName, targetName) => {
    try {
      const sourceParts = this.splitNames(this.expandAbbreviations(sourceName));
      const targetParts = this.splitNames(this.expandAbbreviations(targetName));

      const sourceSet = new Set(sourceParts);
      const targetSet = new Set(targetParts);

      let matchCount = 0;
      for (const word of sourceSet) {
        if (targetSet.has(word)) {
          matchCount++;
        }
      }
      const totalWords = new Set([...sourceSet, ...targetSet]).size;

      const similarityPercentage = (matchCount / totalWords) * 100;

      return similarityPercentage;
    } catch (error) {
      console.error("Error calculating similarity:", error);
      return 0; // or some default value
    }
  };

  // Updated handleCheckSimilarity function to use the new calculateHighestSimilarity logic
  handleCheckSimilarity = (name1, name2, name3) => {
    const similarity12 = this.calculateHighestSimilarity(name1, name2);
    const similarity13 = this.calculateHighestSimilarity(name1, name3);
    const similarity23 = this.calculateHighestSimilarity(name2, name3);
    if (similarity12 === 100 && similarity13 === 100 && similarity23 === 100) {
      console.log("here");

      this.setState({
        similarity12: Math.ceil(similarity12),
        similarity13: Math.ceil(similarity13),
        similarity23: Math.ceil(similarity23),
        showSimilarityPopup: false,
      });
      this.handlePopupResponse("yes");
    } else {
      this.setState({
        similarity12: Math.ceil(similarity12),
        similarity13: Math.ceil(similarity13),
        similarity23: Math.ceil(similarity23),
        showSimilarityPopup: true,
      });
      return;
    }
  };

  // Example ROW click handler
  tableRow_click = (ROW) => {
    let vendorname = localStorage.getItem("billvendorname");
    console.log("ROW", ROW);

    this.setState(
      {
        selectedVendorName: ROW["Vendor Name As Per Master"],
        selectedLedgerName: ROW["Vendor Ledger Name"],
        ROW,
      },
      () => {
        if (ROW?.["Order Type"] && ROW?.["Order Type"] === "PurchaseOrder") {
          return this.handlePopupResponse("yes");
        }
        return this.handleCheckSimilarity(
          vendorname,
          this.state.selectedVendorName,
          this.state.selectedLedgerName,
        );
      },
    );
  };

  handlePopupResponse = (response) => {
    if (response === "yes") {
      this.setState({ showSimilarityPopup: false }, () => {
        this.proceedWithRowClick();
      });
    } else {
      this.setState({ showSimilarityPopup: false });
    }
  };

  proceedWithRowClick = () => {
    const ROW = this.state.ROW;
    Object.keys(ROW)?.map((one) => {
      if (ROW[one] !== null) {
        let willStore_val = ROW[one];

        if (this.state.token === "BillExtract" && one === "TAX") {
          if (willStore_val === "Non-Taxable") {
            this.changeValByserviceID(
              "Tax Category",
              "serviceKey",
              "val",
              "NILL-TAX",
            );
          }
        }

        this.changeValByserviceID(one, "serviceKey", "val", willStore_val);
      }
    });

    this.setState({
      similarityresult12: this.state.similarity12,
    });

    this.setState({ open_popup_select: false, popup_table: false });
    this.props.rerender("noQuit");
  };

  render() {
    const popup_table = this.state.popup_table;
    const open_popup_select = this.state.open_popup_select;

    const { similarity12 } = this.state;

    return (
      <div>
        <Spinner open={this.state.showSpinner} />

        {/* mbp  stylings in the popup.css imported in the simplepopup component*/}
        {this.state.showSimilarityPopup && (
          <div className="modal-overlay">
            <div className="modal-box">
              <table className="table similarity-table">
                <caption>Match Analysis</caption>
                <thead>
                  <tr>
                    <th>% Match</th>
                    <th>Name As Per</th>
                    <th>Name As Per</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{this.state.similarity13.toFixed(2)}%</td>
                    <td>Bill [{localStorage.getItem("billvendorname")}]</td>
                    <td>ERP Ledger [{this.state.selectedLedgerName}]</td>
                  </tr>
                  <tr>
                    <td>{this.state.similarity12.toFixed(2)}%</td>
                    <td>Bill [{localStorage.getItem("billvendorname")}]</td>
                    <td>Vendor Master [{this.state.selectedVendorName}]</td>
                  </tr>
                  <tr>
                    <td>{this.state.similarity23.toFixed(2)}%</td>
                    <td>ERP Ledger [{this.state.selectedLedgerName}]</td>
                    <td>Vendor Master [{this.state.selectedVendorName}]</td>
                  </tr>
                </tbody>
              </table>

              <p className="text-center">
                <em>Do you want to proceed ?</em>{" "}
                <span>
                  <button onClick={() => this.handlePopupResponse("yes")}>
                    Yes
                  </button>
                  <button onClick={() => this.handlePopupResponse("no")}>
                    No
                  </button>
                </span>
              </p>
            </div>
          </div>
        )}

        <div className="view-container">
          {this.props.tree.children?.length > 0 &&
            this.props.tree.children?.map((treenode, index) => {
              if (treenode.type === "section" && treenode.view === "form") {
                return (
                  <div key={index}>
                    <div className="section-title">{treenode.title}</div>

                    <form>
                      {treenode.children?.map((childrenNode, index) => {
                        if (childrenNode.render === "true") {
                          if (
                            childrenNode.type === "select" &&
                            childrenNode.options === undefined &&
                            !childrenNode.dynamic_option
                          ) {
                            this.option_undef(childrenNode);
                          }
                          // if (
                          //   childrenNode?.subtype === "upload_show" &&
                          //   !this.state.stop_flag
                          // ) {
                          //   this.openPDF(null, childrenNode);
                          //   this.setState({ ...this.state, stop_flag: true });
                          // }

                          if (
                            (childrenNode.type === "select" ||
                              childrenNode.type === "search&select" ||
                              (childrenNode.type === "input" &&
                                childrenNode.editable === "false") ||
                              childrenNode.type === "multiselect") &&
                            childrenNode.dynamic_option &&
                            childrenNode.dynamic_option.api_Directory &&
                            !this.props.dynamicOption_Done.includes(
                              childrenNode.serviceKey,
                            )
                          ) {
                            let dynamicOption_Done =
                              this.props.dynamicOption_Done;

                            dynamicOption_Done.push(childrenNode.serviceKey);

                            this.props.updateDynamicOption_Done(
                              dynamicOption_Done,
                            );
                            this.dynamic_option_fn(childrenNode);
                          }
                          if (
                            childrenNode.options &&
                            childrenNode.options.length === 1 &&
                            !this.state?.autoSelected?.[childrenNode.serviceKey]
                          ) {
                            const onlyOption = childrenNode.options[0];

                            // Set state
                            this.setState((prevState) => ({
                              autoSelected: {
                                ...prevState.autoSelected,
                                [childrenNode.serviceKey]: true,
                              },
                            }));

                            const fakeEvent = {
                              target: {
                                name: childrenNode.serviceKey,
                                id: childrenNode.serviceID,
                                value: onlyOption.value,
                              },
                            };

                            // Fire logic after a tiny delay to avoid render-loop
                            setTimeout(() => {
                              this.onDropDownValueChange(fakeEvent);
                              if (childrenNode.onChange_operation) {
                                this.onChange_operation(
                                  childrenNode,
                                  onlyOption.value,
                                );
                              }
                            }, 0);
                          }
                          return (
                            <fieldset
                              key={index}
                              style={{ marginTop: 0, paddingTop: 0 }}
                              className={
                                childrenNode.children !== undefined
                                  ? "field-container col-lg-12 group-container"
                                  : "field-container col-lg-12"
                              }
                            >
                              {childrenNode.children === undefined &&
                                childrenNode.type === "input" &&
                                childrenNode.subtype !== "null" &&
                                childrenNode.subtype !== "date" &&
                                childrenNode.subtype !== "radio" &&
                                !childrenNode.subtype.includes("upload") ? (
                                <div className="row">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {childrenNode.editable &&
                                    childrenNode.editable === "false" ? (
                                    <h6
                                      className="col-lg-3"
                                      id={childrenNode.serviceID}
                                    >
                                      {childrenNode.val
                                        ? childrenNode.val
                                        : "-"}
                                    </h6>
                                  ) : (
                                    <input
                                      type={childrenNode.subtype}
                                      className="col-lg-3"
                                      ref={childrenNode.serviceID}
                                      name={childrenNode.serviceKey}
                                      id={childrenNode.serviceID}
                                      value={
                                        childrenNode.val ? childrenNode.val : ""
                                      }
                                      onBlur={this.onBlur}
                                      onChange={(e) =>
                                        this.myChangeHandler(e, childrenNode)
                                      }
                                    />
                                  )}
                                </div>
                              ) : childrenNode.children === undefined &&
                                childrenNode.type === "input" &&
                                childrenNode.subtype === "date" ? (
                                <div className="row">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {childrenNode.editable &&
                                    childrenNode.editable === "false" ? (
                                    <h6
                                      className="col-lg-3"
                                      id={childrenNode.serviceID}
                                    >
                                      {childrenNode.val
                                        ? this.date_DD_MM_YYYY_TO_YYYY_MM_DD(
                                          childrenNode,
                                        )
                                        : "-"}
                                    </h6>
                                  ) : (
                                    <input
                                      type={childrenNode.subtype}
                                      className="col-lg-3"
                                      ref={childrenNode.serviceID}
                                      name={childrenNode.serviceKey}
                                      id={childrenNode.serviceID}
                                      value={
                                        childrenNode.val
                                          ? this.date_DD_MM_YYYY_TO_YYYY_MM_DD(
                                            childrenNode,
                                          )
                                          : ""
                                      }
                                      onBlur={this.onBlur}
                                      onChange={(e) =>
                                        this.myChangeHandler(
                                          e,
                                          childrenNode,
                                          "date",
                                        )
                                      }
                                    />
                                  )}
                                </div>
                              ) : childrenNode.children === undefined &&
                                childrenNode.type === "textarea" ? (
                                <div className="row">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>
                                  {childrenNode.editable &&
                                    childrenNode.editable === "false" ? (
                                    <h6
                                      className="col-lg-3"
                                      id={childrenNode.serviceID}
                                    >
                                      {childrenNode.val
                                        ? childrenNode.val
                                        : "-"}
                                    </h6>
                                  ) : (
                                    <textarea
                                      type={childrenNode.subtype}
                                      className="col-lg-3"
                                      ref={childrenNode.serviceID}
                                      name={childrenNode.serviceKey}
                                      id={childrenNode.serviceID}
                                      value={childrenNode.val}
                                      onBlur={this.onBlur}
                                      onChange={(e) =>
                                        this.myChangeHandler(e, childrenNode)
                                      }
                                      rows="4"
                                      cols="50"
                                    />
                                  )}
                                </div>
                              ) : childrenNode.children === undefined &&
                                childrenNode.type === "input" &&
                                childrenNode.subtype === "radio" ? (
                                <div className="row">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  <div className="col-lg-3">
                                    <div className="row">
                                      {childrenNode.values &&
                                        childrenNode.values?.length &&
                                        childrenNode.values?.map(
                                          (each, index) => {
                                            return (
                                              <div className="col-lg-6">
                                                {childrenNode.editable &&
                                                  childrenNode.editable ===
                                                  "false" ? (
                                                  each &&
                                                    childrenNode.val === each ? (
                                                    <h6
                                                      className="col-lg-3"
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                    >
                                                      {each ? each : "-"}
                                                    </h6>
                                                  ) : (
                                                    "-"
                                                  )
                                                ) : (
                                                  <>
                                                    <input
                                                      type={
                                                        childrenNode.subtype
                                                      }
                                                      name={
                                                        childrenNode.serviceKey
                                                      }
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      value={each}
                                                      key={each}
                                                      checked={
                                                        each ===
                                                        childrenNode.val
                                                      }
                                                      onBlur={this.onBlur}
                                                      onChange={(e) =>
                                                        this.myChangeHandler(
                                                          e,
                                                          childrenNode,
                                                        )
                                                      }
                                                    />
                                                    {each}
                                                  </>
                                                )}
                                              </div>
                                            );
                                          },
                                        )}
                                    </div>
                                  </div>
                                </div>
                              ) : childrenNode.children === undefined &&
                                childrenNode.type === "input_search" ? (
                                <div className="row">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  <input
                                    type={childrenNode.subtype}
                                    className="col-lg-3"
                                    ref={childrenNode.serviceID}
                                    name={childrenNode.serviceKey}
                                    id={childrenNode.serviceID}
                                    value={
                                      childrenNode.val ? childrenNode.val : ""
                                    }
                                    onBlur={this.onBlur}
                                    onChange={(e) =>
                                      this.myChangeHandler(e, childrenNode)
                                    }
                                  />
                                  <button
                                    className="btn btn-link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.input_select_fn(childrenNode);
                                      this.setState({
                                        open_popup_select: true,
                                      });
                                    }}
                                  >
                                    Search&nbsp;{childrenNode.title}
                                  </button>
                                  {/* mbp */}

                                  {open_popup_select && popup_table && (
                                    <Popup
                                      content={
                                        <>
                                          <div className="row m-4">
                                            <input
                                              type="text"
                                              autoFocus
                                              className="col-lg-6"
                                              name="search"
                                              placeholder="search here"
                                              value={popup_table.search}
                                              onChange={
                                                this.on_popup_table_search
                                              }
                                            />
                                          </div>

                                          <div className="row m-4">
                                            {!popup_table.filteredData
                                              ?.length ? (
                                              <div>No match found</div>
                                            ) : (
                                              <Table striped bordered hover>
                                                <thead>
                                                  <tr>
                                                    {popup_table.header?.map(
                                                      (each, indx) => {
                                                        return (
                                                          <th key={indx}>
                                                            {each}
                                                          </th>
                                                        );
                                                      },
                                                    )}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {popup_table.filteredData?.map(
                                                    (each, index) => {
                                                      return (
                                                        <tr
                                                          key={index}
                                                          onClick={() =>
                                                            this.tableRow_click(
                                                              each,
                                                            )
                                                          }
                                                        >
                                                          {popup_table.header?.map(
                                                            (one, indx) => {
                                                              return (
                                                                <td>
                                                                  {
                                                                    each[one]
                                                                  }{" "}
                                                                </td>
                                                              );
                                                            },
                                                          )}
                                                        </tr>
                                                      );
                                                    },
                                                  )}
                                                </tbody>
                                              </Table>
                                            )}
                                          </div>
                                        </>
                                      }
                                      handleClose={() =>
                                        this.setState({
                                          open_popup_select: false,
                                          popup_table: false,
                                        })
                                      }
                                    />
                                  )}
                                </div>
                              ) : childrenNode.children === undefined &&
                                childrenNode.type ===
                                "input_vendormasternamestatus" ? (
                                <div className="row   align-items-center ">
                                  <div className="col-lg-3">
                                    <Tooltip
                                      title={
                                        childrenNode.tooltip
                                          ? childrenNode.tooltip
                                          : childrenNode.title
                                      }
                                    >
                                      <span>
                                        {childrenNode.title}:{" "}
                                        <span style={{ color: "red" }}>
                                          {childrenNode.mandatory === "true"
                                            ? "*"
                                            : null}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {childrenNode.editable &&
                                    childrenNode.editable === "false" ? (
                                    <h6
                                      className="col-lg-3"
                                      id={childrenNode.serviceID}
                                    >
                                      {childrenNode.val
                                        ? childrenNode.val
                                        : "-"}
                                    </h6>
                                  ) : (
                                    <input
                                      type={childrenNode.subtype}
                                      className="col-lg-3"
                                      ref={childrenNode.serviceID}
                                      name={childrenNode.serviceKey}
                                      id={childrenNode.serviceID}
                                      value={
                                        childrenNode.val ? childrenNode.val : ""
                                      }
                                      onBlur={this.onBlur}
                                    />
                                  )}
                                  <div className="col-lg-3 px-2 d-flex align-items-center">
                                    <Tooltip
                                      title={`${this.state.similarityresult12}%  match between Vendor Name and Vendor Name As Per Mater`}
                                    >
                                      <span>
                                        <ProgressComponent
                                          percentage={
                                            this.state.similarityresult12
                                          }
                                        />
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>
                              ) : //mbp
                                childrenNode.children === undefined &&
                                  childrenNode.type ===
                                  "input_ledgernamestatus" ? (
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <Tooltip
                                        title={
                                          childrenNode.tooltip
                                            ? childrenNode.tooltip
                                            : childrenNode.title
                                        }
                                      >
                                        <span>
                                          {childrenNode.title}:{" "}
                                          <span style={{ color: "red" }}>
                                            {childrenNode.mandatory === "true"
                                              ? "*"
                                              : null}
                                          </span>
                                        </span>
                                      </Tooltip>
                                    </div>
                                    {childrenNode.editable &&
                                      childrenNode.editable === "false" ? (
                                      <h6
                                        className="col-lg-3"
                                        id={childrenNode.serviceID}
                                      >
                                        {childrenNode.val
                                          ? childrenNode.val
                                          : "-"}
                                      </h6>
                                    ) : (
                                      <input
                                        type={childrenNode.subtype}
                                        className="col-lg-3"
                                        ref={childrenNode.serviceID}
                                        name={childrenNode.serviceKey}
                                        id={childrenNode.serviceID}
                                        value={
                                          childrenNode.val ? childrenNode.val : ""
                                        }
                                        onBlur={this.onBlur}
                                      />
                                    )}
                                    <button>Status</button>
                                  </div>
                                ) : //

                                  childrenNode.children === undefined &&
                                    childrenNode.type.includes("popup_select") ? (
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <Tooltip
                                          title={
                                            childrenNode.tooltip
                                              ? childrenNode.tooltip
                                              : childrenNode.title
                                          }
                                        >
                                          <span>
                                            {childrenNode.title}:{" "}
                                            <span style={{ color: "red" }}>
                                              {childrenNode.mandatory === "true"
                                                ? "*"
                                                : null}
                                            </span>
                                          </span>
                                        </Tooltip>
                                      </div>
                                      <input
                                        type={childrenNode.subtype}
                                        className="col-lg-3"
                                        ref={childrenNode.serviceID}
                                        name={childrenNode.serviceKey}
                                        id={childrenNode.serviceID}
                                        value={
                                          childrenNode.val ? childrenNode.val : ""
                                        }
                                        onBlur={this.onBlur}
                                        onChange={(e) =>
                                          this.myChangeHandler(e, childrenNode)
                                        }
                                        disabled
                                      />
                                      <button
                                        className="btn btn-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.popup_select_fn(childrenNode);
                                          this.setState({
                                            open_popup_select: true,
                                          });
                                        }}
                                      >
                                        Search PO/IP
                                      </button>

                                      {open_popup_select && popup_table && (
                                        <Popup
                                          content={
                                            <>
                                              <div className="row m-4">
                                                <input
                                                  type="text"
                                                  autoFocus
                                                  className="col-lg-6"
                                                  name="search"
                                                  placeholder="search here"
                                                  value={popup_table.search}
                                                  onChange={
                                                    this.on_popup_table_search
                                                  }
                                                />
                                              </div>

                                              <div className="row m-4">
                                                {!popup_table.filteredData
                                                  ?.length ? (
                                                  <div>No match found</div>
                                                ) : (
                                                  <Table striped bordered hover>
                                                    <thead>
                                                      <tr>
                                                        {popup_table.header?.map(
                                                          (each, indx) => {
                                                            return (
                                                              <th key={indx}>
                                                                {each}
                                                              </th>
                                                            );
                                                          },
                                                        )}
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {popup_table.filteredData?.map(
                                                        (each, index) => {
                                                          return (
                                                            <tr
                                                              key={index}
                                                              onClick={() => {
                                                                if (!each.disabled)
                                                                  this.tableRow_click(
                                                                    each,
                                                                  );
                                                              }}
                                                              style={
                                                                each.disabled
                                                                  ? {
                                                                    opacity: 0.5,
                                                                    pointerEvents:
                                                                      "none",
                                                                  }
                                                                  : null
                                                              }
                                                            >
                                                              {popup_table.header?.map(
                                                                (one, indx) => {
                                                                  return (
                                                                    <td>
                                                                      {
                                                                        each[one]
                                                                      }{" "}
                                                                    </td>
                                                                  );
                                                                },
                                                              )}
                                                            </tr>
                                                          );
                                                        },
                                                      )}
                                                    </tbody>
                                                  </Table>
                                                )}
                                              </div>
                                            </>
                                          }
                                          handleClose={() =>
                                            this.setState({
                                              open_popup_select: false,
                                              popup_table: false,
                                            })
                                          }
                                        />
                                      )}
                                    </div>
                                  ) : (childrenNode.children === undefined &&
                                    childrenNode.type === "select") ||
                                    childrenNode.type === "search&select" ? (
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <Tooltip
                                          title={
                                            childrenNode.tooltip
                                              ? childrenNode.tooltip
                                              : childrenNode.title
                                          }
                                        >
                                          <span>
                                            {childrenNode.title}:{" "}
                                            <span style={{ color: "red" }}>
                                              {childrenNode.mandatory === "true"
                                                ? "*"
                                                : null}
                                            </span>
                                          </span>
                                        </Tooltip>
                                      </div>

                                      {childrenNode.editable &&
                                        childrenNode.editable === "false" ? (
                                        <h6
                                          className="col-lg-3"
                                          id={childrenNode.serviceID}
                                        >
                                          {childrenNode.val
                                            ? childrenNode.val
                                            : "-"}
                                        </h6>
                                      ) : !childrenNode.options ||
                                        childrenNode.options?.length < 10 ? (
                                        <>
                                          <select
                                            className="col-lg-3"
                                            name={childrenNode.serviceKey}
                                            id={childrenNode.serviceID}
                                            value={
                                              childrenNode.options?.length === 1
                                                ? childrenNode?.options[0]?.value
                                                : childrenNode?.val
                                            }
                                            onChange={(e) => {
                                              this.onDropDownValueChange(e);
                                              if (childrenNode.onChange_operation)
                                                this.onChange_operation(
                                                  childrenNode,
                                                  e.target.value,
                                                );
                                            }}
                                          >
                                            <option value="">select</option>
                                            {childrenNode.options !== undefined &&
                                              childrenNode.options &&
                                              childrenNode.options?.map(
                                                (opt, optKey) => (
                                                  <option
                                                    key={optKey}
                                                    value={opt.value}
                                                  >
                                                    {opt.label}
                                                  </option>
                                                ),
                                              )}
                                          </select>
                                          {childrenNode.type === "search&select" ? (
                                            <IconButton
                                              edge="end"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.dynamic_option_fn(
                                                  childrenNode,
                                                );
                                              }}
                                            >
                                              <SearchIcon />
                                            </IconButton>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : childrenNode.editable &&
                                        childrenNode.editable === "false" ? (
                                        <h6
                                          className="col-lg-3"
                                          id={childrenNode.serviceID}
                                        >
                                          {childrenNode.val
                                            ? childrenNode.val
                                            : "-"}
                                        </h6>
                                      ) : (
                                        <>
                                          <Select
                                            className="col-lg-3"
                                            name={childrenNode.serviceKey}
                                            id={childrenNode.serviceID}
                                            style={{
                                              padding: "0 0",
                                              width: "100%",
                                            }}
                                            onChange={(value) => {
                                              this.onDropDownValueChange({
                                                target: {
                                                  name: childrenNode.serviceKey,
                                                  id: childrenNode.serviceID,
                                                  value: value.value,
                                                },
                                              });
                                              if (childrenNode.onChange_operation)
                                                this.onChange_operation(
                                                  childrenNode,
                                                  value.value,
                                                );
                                            }}
                                            value={
                                              childrenNode.options &&
                                                childrenNode.options?.length
                                                ? childrenNode.options.find(
                                                  (each) =>
                                                    each.value ===
                                                    childrenNode.val,
                                                )
                                                : null
                                            }
                                            options={childrenNode.options}
                                            isSeachable={true}
                                            isMulti={false}
                                          />
                                          {childrenNode.type === "search&select" ? (
                                            <IconButton
                                              edge="end"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.dynamic_option_fn(
                                                  childrenNode,
                                                );
                                              }}
                                            >
                                              <SearchIcon />
                                            </IconButton>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )}
                                    </div>
                                  ) : childrenNode.children === undefined &&
                                    childrenNode.type === "multiselect" ? (
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <Tooltip
                                          title={
                                            childrenNode.tooltip
                                              ? childrenNode.tooltip
                                              : childrenNode.title
                                          }
                                        >
                                          <span>
                                            {childrenNode.title}:{" "}
                                            <span style={{ color: "red" }}>
                                              {childrenNode.mandatory === "true"
                                                ? "*"
                                                : null}
                                            </span>
                                          </span>
                                        </Tooltip>
                                      </div>

                                      {childrenNode.editable &&
                                        childrenNode.editable === "false" ? (
                                        <h6
                                          className="col-lg-3"
                                          id={childrenNode.serviceID}
                                        >
                                          {childrenNode.val
                                            ? childrenNode.val
                                            : "-"}
                                        </h6>
                                      ) : (
                                        <Select
                                          className="col-lg-3"
                                          name={childrenNode.serviceKey}
                                          id={childrenNode.serviceID}
                                          onChange={(value) => {
                                            let VAL = value?.map(
                                              (each) => each.value,
                                            );
                                            VAL = VAL.join("#");
                                            this.onDropDownValueChange({
                                              target: {
                                                name: childrenNode.serviceKey,
                                                id: childrenNode.serviceID,
                                                value: VAL,
                                              },
                                            });
                                            if (childrenNode.onChange_operation)
                                              this.onChange_operation(
                                                childrenNode,
                                                VAL,
                                              );
                                          }}
                                          value={
                                            childrenNode.options &&
                                              childrenNode.options?.length
                                              ? childrenNode.options.filter(
                                                (each) =>
                                                  childrenNode.val
                                                    .split("#")
                                                    .includes(each.value),
                                              )
                                              : null
                                          }
                                          options={childrenNode.options}
                                          isSeachable={true}
                                          isMulti={true}
                                        />
                                      )}
                                    </div>
                                  ) : childrenNode.children === undefined &&
                                    childrenNode.type === "input" &&
                                    childrenNode.subtype.includes("upload") ? (
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <Tooltip
                                          title={
                                            childrenNode.tooltip
                                              ? childrenNode.tooltip
                                              : childrenNode.title
                                          }
                                        >
                                          <span>
                                            {childrenNode.title}:{" "}
                                            <span style={{ color: "red" }}>
                                              {childrenNode.mandatory === "true"
                                                ? "*"
                                                : null}
                                            </span>
                                          </span>
                                        </Tooltip>
                                      </div>
                                      <div className="col-lg-3 p-0">
                                        <Button
                                          disabled={
                                            childrenNode.editable &&
                                            childrenNode.editable === "false"
                                          }
                                          component="label"
                                          variant="contained"
                                          color="primary"
                                          startIcon={<CloudUploadIcon />}
                                          sx={{ marginTop: 1 }}
                                        >
                                          Upload File
                                          <VisuallyHiddenInput
                                            type="file"
                                            accept=".pdf"
                                            onChange={(e) => {
                                              if (
                                                childrenNode.editable === "true"
                                              ) {
                                                let event = {
                                                  target: {
                                                    id: childrenNode.serviceID,
                                                    name: childrenNode.serviceKey,
                                                    files: e.target.files,
                                                  },
                                                };
                                                this.onUpload(event, childrenNode);
                                              }
                                            }}
                                          />
                                        </Button>
                                        {this.state.ValidationError[
                                          `${childrenNode.serviceID}`
                                        ] && (
                                            <Typography
                                              variant="body2"
                                              color="error"
                                              sx={{ marginTop: 1 }}
                                            >
                                              {
                                                this.state.ValidationError[
                                                `${childrenNode.serviceID}`
                                                ]
                                              }
                                            </Typography>
                                          )}
                                      </div>

                                      {childrenNode.val && (
                                        <div className="col-lg-3">
                                          <button
                                            className="btn btn-success"
                                            onClick={(e) =>
                                              this.openPDF(e, childrenNode)
                                            }
                                          >
                                            Open
                                          </button>
                                        </div>
                                      )}

                                      {childrenNode.val &&
                                        this.state.popData_PDF &&
                                        this.state.showPopUP_PDF &&
                                        this.state.showPopUP_PDF ===
                                        childrenNode.serviceID ? (
                                        <Popup
                                          content={
                                            <>
                                              {/* <iframe src={ URL.createObject.keysURL(this.state[childrenNode.serviceID]) } width="100%" height="500px" /> */}

                                              <iframe
                                                src={
                                                  this.state.fileType.toLowerCase() ===
                                                    "pdf"
                                                    ? `data:application/pdf;base64,${this.state.popData_PDF}`
                                                    : `data:image/${this.state.fileType};base64,${this.state.popData_PDF}`
                                                }
                                                title="pdf-viewer"
                                                style={{
                                                  width: "100%",
                                                  height: "500px",
                                                }}
                                              />
                                            </>
                                          }
                                          handleClose={() =>
                                            this.setState({ showPopUP_PDF: null })
                                          }
                                        />
                                      ) : null}
                                    </div>
                                  ) : childrenNode.children !== undefined &&
                                    childrenNode.type === "group" ? (
                                    <legend>{childrenNode.title}</legend>
                                  ) : null}

                              {childrenNode.children !== undefined
                                ? childrenNode.children?.map(
                                  (grandChild, index) => {
                                    return (
                                      <div
                                        className="row field-container"
                                        key={index}
                                      >
                                        <div className="col-lg-3">
                                          {grandChild.title}:
                                        </div>
                                        <input
                                          type="text"
                                          name={grandChild.serviceKey}
                                          id={childrenNode.serviceID}
                                          className="col-lg-3"
                                          onChange={(e) =>
                                            this.myChangeHandler(
                                              e,
                                              childrenNode,
                                            )
                                          }
                                        />
                                      </div>
                                    );
                                  },
                                )
                                : null}
                            </fieldset>
                          );
                        }
                      })}
                    </form>
                  </div>
                );
              }
            })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    VR2_Form_Json: state.VR2.VR2_Form_Json,
    changeLogs: state.VR2.changeLogs,
    storeVals: state.VR2.storeVals,
    athenaStorage: state.VR2.athenaStorage,
    dependency_json: state.VR2.dependency_json,
    dynamicOption_Done: state.VR2.dynamicOption_Done,
    ORG_ID_CONST: state.VR2.ORG_ID_CONST,
    userData: state.login.userData,
  };
}

export default connect(mapStateToProps, {
  handleTreeChange,
  updateChangeLogs,
  updateStoreVals,
  showAlert,
  updateAthenaStorage,
  update_one_side_PDF_Key,
  updateDynamicOption_Done,
  Set_ORG_ID_CONST,
})(form);
